var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup27(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "7sj8aqcy0a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.666667 0 0 0 0 0.501961 0 0 0 0 0.996078 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521 -206)",
    filter: "url(#7sj8aqcy0a)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522 257.5c0 8.561 6.94 15.5 15.5 15.5 8.56 0 15.5-6.939 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5zM551 226.214 537 235l-14-8.786V207h28zM530.5 207v23M543.5 207v23M530 253.5h14M530 261.5h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 238.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM557 257.5c0 8.561 6.94 15.5 15.5 15.5 8.56 0 15.5-6.939 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5zM586 226.214 572 235l-14-8.786V207h28zM566.5 207v23M579.5 207v23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 238.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM572.5 248l3.132 5.657 6.368 1.218-4.433 4.715.805 6.41-5.872-2.743-5.872 2.743.805-6.41-4.433-4.715 6.368-1.218z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27);
export default __webpack_public_path__ + "static/media/group-27.af60bddea557d1793962992e22661ba0.svg";
export { ForwardRef as ReactComponent };